import React, { useEffect, useState } from "react";

import EmailIcon from "@mui/icons-material/Email";

import AgentsList from "./AgentsList";
import ViewIconSVG from "../../common/customSVGs/ViewIconSVG";

let columns = [
  // {
  //   key: 1,
  //   label: "",
  //   id: "srr",
  //   width: 10,
  //   bodypadding: 0,
  //   tooltipMsg: "Premium Account",
  // },
  {
    key: 1,
    label: "",
    id: "sr",
    minWidth: 10,
  },
  {
    key: 2,
    label: "Agent name",
    id: "full_name",
  },
  {
    key: 3,
    label: "Office",
    dropdown: true,
    id: "office_name",
    width: 200,
  },
  {
    key: 4,
    label: "Email",
    id: "email",
  },
  {
    key: 5,
    label: "Sales representative",
    dropdown: true,
    id: "rep_name",
  },
  {
    key: 7,
    label: "Status",
    id: "agent_status",
    dropdown: true,
    width: 200,
  },
];

const SalesManagerREAgents = ({
  base_route,
  isRepresentative = false,
  isSalesManager = false,
}) => {
  const [sm_tabData, setSM_tabData] = useState({
    sm_columns: columns,
    sm_btn_texts: false,
  });

  useEffect(() => {
    if (isRepresentative) {
      if (!columns.find((e) => e.key === 6)) {
        columns.push({
          key: 6,
          label: "Total monitoring",
          id: "agent_properties_count",
          alignProp: "center",
        });
      }
      if (!columns.find((e) => e.key === 8)) {
        columns.push({
          key: 8,
          id: "view",
          tooltipMsg: "View Properties",
          label: "",
          width: 50,
          content: <ViewIconSVG />,
        });
      }
      if (!columns.find((e) => e.key === 9)) {
        columns.push({
          key: 9,
          id: "resend-email",
          tooltipMsg: "Resend Welcome Email",
          label: "",
          width: 50,
          content: <EmailIcon />,
          sx: { color: "#15be53" },
        });
      }

      columns.forEach((col) => {
        if (col.id === "agent_status") {
          col.width = "100";
        }
      });

      columns.sort(function (a, b) {
        return a.key - b.key;
      });
      setSM_tabData((prevState) => ({ ...prevState, sm_columns: columns }));
    } else {
      columns = columns.filter(function (e) {
        return e.key !== 6 && e.key !== 8 && e.key !== 9;
      });

      columns.forEach((col) => {
        if (col.id === "agent_status") {
          col.width = "200";
        }
      });

      setSM_tabData((prevState) => ({ ...prevState, sm_columns: columns }));
    }
  }, [isRepresentative]);

  return (
    <div>
      <AgentsList
        base_route={base_route}
        sm_tabData={sm_tabData}
        isSalesManager={isSalesManager}
        isRepresentative={isRepresentative}
      />
    </div>
  );
};

export default SalesManagerREAgents;
